// import { useState, useEffect } from 'react';
// import {
//   Layers,
//   Ruler,
//   Home,
//   X,
//   PanelRightClose,
//   NotebookPen,
// } from 'lucide-react';
// import { easeOut } from 'ol/easing';
// import { INITIAL_VIEW_STATE } from '../hooks/useMapInstance';
// import { useMap } from '@/providers/MapProvider';
// import { BasemapPanel, BasemapType } from './controls/BasemapControl';
// import { MeasurePanel } from './controls/MeasureControl';
// import { cn } from '@/lib/utils';
// import { Card, CardContent, CardHeader } from '@/components/ui/card';
// import { Button } from '@/components/ui/button';
// import {
//   Tooltip,
//   TooltipContent,
//   TooltipProvider,
//   TooltipTrigger,
// } from '@/components/ui/tooltip';
// import { Separator } from '@/components/ui/separator';
// import { useMapInteraction } from '@/providers/MapAssetsProvider';
// import { useMapStore } from '@/stores/mapStore';

// type ActivePanel = 'basemap' | 'measure' | 'sidebar' | 'note' | null;

// interface MapControlProps {
//   sidebarOpen: boolean;
//   toggleSidebar: () => void;
// }

// export const MapControls = ({
//   sidebarOpen,
//   toggleSidebar,
// }: MapControlProps) => {
//   const [activePanel, setActivePanel] = useState<ActivePanel>(null);

//   const { mapInstanceRef } = useMap();

//   const {
//     interactionMode,
//     setInteractionMode,
//     resetInteraction,
//     activeBasemap,
//     setActiveBasemap,
//   } = useMapStore();

//   const handlePanelToggle = (
//     panel: 'basemap' | 'measure' | 'sidebar' | 'note',
//   ) => {
//     setActivePanel((prev) => (prev === panel ? null : panel));
//   };

//   const handleNoteToggle = () => {
//     if (interactionMode === 'addNote') {
//       resetInteraction();
//     } else {
//       setInteractionMode('addNote');
//     }
//   };

//   const handleLayerToggle = () => {
//     handlePanelToggle('sidebar');
//     toggleSidebar();
//   };

//   const handleGoHome = () => {
//     const map = mapInstanceRef.current;
//     if (!map) return;
//     map.getView().animate({
//       center: INITIAL_VIEW_STATE.center,
//       zoom: INITIAL_VIEW_STATE.zoom,
//       duration: 0,
//       easing: easeOut,
//     });
//   };

//   useEffect(() => {
//     const handleKeyDown = (e: KeyboardEvent) => {
//       if (e.key === 'Escape') setActivePanel(null);
//     };
//     window.addEventListener('keydown', handleKeyDown);
//     return () => window.removeEventListener('keydown', handleKeyDown);
//   }, []);

//   return (
//     <div className="absolute top-20 left-4 z-1 flex items-start gap-2">
//       <Card>
//         <CardContent className="p-1.5">
//           <div className="flex flex-col items-center gap-1">
//             <ToolbarButton
//               title="Basemaps"
//               isActive={activePanel === 'basemap'}
//               onClick={() => handlePanelToggle('basemap')}
//             >
//               <Layers size={20} />
//             </ToolbarButton>

//             <ToolbarButton
//               title="Measure Tool"
//               isActive={activePanel === 'measure'}
//               onClick={() => handlePanelToggle('measure')}
//             >
//               <Ruler size={20} />
//             </ToolbarButton>

//             <ToolbarButton
//               title="Toggle Layers"
//               isActive={sidebarOpen}
//               onClick={handleLayerToggle}
//             >
//               <PanelRightClose size={20} />
//             </ToolbarButton>

//             <ToolbarButton
//               isActive={interactionMode === 'addNote'}
//               title="Add Note"
//               onClick={handleNoteToggle}
//             >
//               <NotebookPen size={20} />
//             </ToolbarButton>

//             <Separator className="my-1" />

//             <ToolbarButton title="Reset View" onClick={handleGoHome}>
//               <Home size={20} />
//             </ToolbarButton>
//           </div>
//         </CardContent>
//       </Card>

//       {activePanel && activePanel !== 'note' && activePanel !== 'sidebar' && (
//         <Card
//           className={cn(
//             'w-65 origin-left transition-all duration-300 ease-in-out',
//             activePanel
//               ? 'scale-x-100 opacity-100'
//               : 'scale-x-95 opacity-0 pointer-events-none',
//           )}
//         >
//           <div className="flex flex-col">
//             <CardHeader className="flex flex-row items-center justify-between border-b p-3 pb-2">
//               <h3 className="font-semibold text-sm leading-none tracking-tight">
//                 {activePanel === 'basemap' ? 'Basemap Layers' : 'Measure Tool'}
//               </h3>
//               <Button
//                 variant="ghost"
//                 size="icon"
//                 onClick={() => setActivePanel(null)}
//                 className="h-6 w-6 rounded-full hover:bg-muted"
//               >
//                 <X size={14} />
//               </Button>
//             </CardHeader>

//             <CardContent className="p-2">
//               {activePanel === 'basemap' && (
//                 <BasemapPanel
//                   activeBasemap={activeBasemap}
//                   setActiveBasemap={setActiveBasemap}
//                 />
//               )}
//               {activePanel === 'measure' && <MeasurePanel />}
//             </CardContent>
//           </div>
//         </Card>
//       )}
//     </div>
//   );
// };

// interface ToolbarButtonProps {
//   title: string;
//   onClick: () => void;
//   isActive?: boolean;
//   children: any;
// }

// const ToolbarButton = ({
//   title,
//   onClick,
//   isActive = false,
//   children,
// }: ToolbarButtonProps) => {
//   return (
//     <TooltipProvider delayDuration={100}>
//       <Tooltip>
//         <TooltipTrigger className="hover:bg-secondary/20" asChild>
//           <Button
//             variant="ghost"
//             size="icon"
//             onClick={onClick}
//             data-active={isActive}
//             className="h-9 w-9 data-[active=true]:bg-secondary data-[active=true]:text-secondary-foreground"
//           >
//             {children}
//           </Button>
//         </TooltipTrigger>
//         <TooltipContent
//           className="bg-secondary text-secondary text-secondary-foreground"
//           side="right"
//           sideOffset={5}
//         >
//           <p>{title}</p>
//         </TooltipContent>
//       </Tooltip>
//     </TooltipProvider>
//   );
// };
// @ts-nocheck
import { useState, useEffect, useRef } from 'react';
import {
  Layers,
  Ruler,
  Home,
  X,
  PanelRightClose,
  NotebookPen,
} from 'lucide-react';
import { easeOut } from 'ol/easing';

import { useMap } from '@/providers/MapProvider';
import { BasemapPanel } from './controls/BasemapControl';
import { MeasurePanel } from './controls/MeasureControl';
import { cn } from '@/lib/utils';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { Separator } from '@/components/ui/separator';
import { useMapStore } from '@/stores/mapStore';
import { INITIAL_VIEW_STATE } from '../hooks/useMapInstance';

type ActivePanel = 'basemap' | 'measure' | 'sidebar' | 'note' | null;

interface MapControlProps {
  sidebarOpen: boolean;
  toggleSidebar: () => void;
}

function useClickOutside(
  ref: React.RefObject<HTMLElement | null>,
  handler: () => void,
  activePanel: ActivePanel,
) {
  useEffect(() => {
    const listener = (event: MouseEvent | TouchEvent) => {
      const target = event.target as Element;

      if (!ref.current || ref.current.contains(target as Node)) {
        return;
      }

      if (activePanel === 'measure' && target.closest('.ol-viewport')) {
        return;
      }

      handler();
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler, activePanel]);
}

export const MapControls = ({
  sidebarOpen,
  toggleSidebar,
}: MapControlProps) => {
  const [activePanel, setActivePanel] = useState<ActivePanel>(null);
  const containerRef = useRef<HTMLDivElement | null>(null);

  const { map } = useMap();
  const {
    interactionMode,
    setInteractionMode,
    resetInteraction,
    activeBasemap,
    setActiveBasemap,
  } = useMapStore();

  // Use the updated hook
  useClickOutside(
    containerRef,
    () => {
      // Only auto-close these panels
      if (activePanel === 'basemap' || activePanel === 'measure') {
        setActivePanel(null);
      }
    },
    activePanel,
  );

  const handlePanelToggle = (panel: ActivePanel) => {
    setActivePanel((prev) => (prev === panel ? null : panel));
  };

  const handleLayerToggle = () => {
    if (!sidebarOpen) setActivePanel(null);
    toggleSidebar();
  };

  const handleNoteToggle = () => {
    if (interactionMode === 'addNote') {
      resetInteraction();
    } else {
      setActivePanel(null);
      setInteractionMode('addNote');
    }
  };

  const handleGoHome = () => {
    if (!map) return;
    map.getView().animate({
      center: INITIAL_VIEW_STATE.center,
      zoom: INITIAL_VIEW_STATE.zoom,
      duration: 500,
      easing: easeOut,
    });
  };

  return (
    <div
      ref={containerRef}
      className="absolute top-20 left-4 z-10 flex items-start gap-3 pointer-events-auto"
    >
      <Card className="shadow-md border-border bg-card">
        <CardContent className="p-1.5 pt-0 pb-0 flex flex-col gap-1">
          <ToolbarButton
            title="Basemaps"
            isActive={activePanel === 'basemap'}
            onClick={() => handlePanelToggle('basemap')}
          >
            <Layers size={20} />
          </ToolbarButton>

          <ToolbarButton
            title="Measure Tool"
            isActive={activePanel === 'measure'}
            onClick={() => handlePanelToggle('measure')}
          >
            <Ruler size={20} />
          </ToolbarButton>

          <ToolbarButton
            title={sidebarOpen ? 'Hide Layers' : 'Show Layers'}
            isActive={sidebarOpen}
            onClick={handleLayerToggle}
          >
            <PanelRightClose size={20} />
          </ToolbarButton>

          <ToolbarButton
            title={
              interactionMode === 'addNote' ? 'Stop Adding Note' : 'Add Note'
            }
            isActive={interactionMode === 'addNote'}
            onClick={handleNoteToggle}
          >
            <NotebookPen size={20} />
          </ToolbarButton>

          <Separator className="my-1 bg-border" />

          <ToolbarButton title="Reset View" onClick={handleGoHome}>
            <Home size={20} />
          </ToolbarButton>
        </CardContent>
      </Card>

      <div
        className={cn(
          'transition-all duration-300 ease-[cubic-bezier(0.16,1,0.3,1)] origin-left absolute left-14',
          activePanel && activePanel !== 'note' && activePanel !== 'sidebar'
            ? 'opacity-100 translate-x-0 scale-100'
            : 'opacity-0 -translate-x-4 scale-95 pointer-events-none',
        )}
      >
        {activePanel && (
          <Card className="w-72 shadow-xl overflow-hidden bg-card ring-1 ring-ring-secondary">
            <CardHeader className="flex flex-row items-center justify-between border-b p-3 py-2.5 bg-muted/40">
              <h3 className="font-semibold text-sm text-foreground">
                {activePanel === 'basemap'
                  ? 'Basemap Layers'
                  : 'Measurement Tools'}
              </h3>
              <Button
                variant="ghost"
                size="icon"
                onClick={() => setActivePanel(null)}
                className="h-6 w-6 rounded-full hover:bg-muted text-muted-foreground hover:text-foreground"
              >
                <X size={14} />
              </Button>
            </CardHeader>

            <CardContent className="p-3 bg-card text-card-foreground">
              {activePanel === 'basemap' && (
                <BasemapPanel
                  activeBasemap={activeBasemap}
                  setActiveBasemap={setActiveBasemap}
                />
              )}
              {activePanel === 'measure' && <MeasurePanel />}
            </CardContent>
          </Card>
        )}
      </div>
    </div>
  );
};

interface ToolbarButtonProps {
  title: string;
  onClick: () => void;
  isActive?: boolean;
  children: React.ReactNode;
}

const ToolbarButton = ({
  title,
  onClick,
  isActive = false,
  children,
}: ToolbarButtonProps) => {
  return (
    <TooltipProvider delayDuration={0}>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant={isActive ? 'secondary' : 'ghost'}
            size="icon"
            onClick={onClick}
            className={cn(
              'h-9 w-9 transition-colors duration-200 ',
              isActive
                ? 'bg-primary text-white hover:bg-primary/90 shadow-sm'
                : 'text-foreground hover:bg-muted hover:text-foreground',
            )}
          >
            {children}
          </Button>
        </TooltipTrigger>
        <TooltipContent
          side="right"
          sideOffset={10}
          className="bg-primary text-white border-border text-xs font-medium px-2 py-1 z-1"
        >
          {title}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
